import { render, staticRenderFns } from "./FalabMedicalForm.vue?vue&type=template&id=41a6bd3e"
import script from "./FalabMedicalForm.vue?vue&type=script&lang=js"
export * from "./FalabMedicalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports